import React from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  ButtonGroup,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Text,
  Button,
  useToast,
} from '@chakra-ui/react';
import { T } from '@transifex/react';
import { t } from '@transifex/native';
import { IMFAModalProps } from './types';
import { useUpdateOrganizationMutation } from 'features/home/services/identity/organization';

const MFADeactivationModal = (props: IMFAModalProps) => {
  const toast = useToast();
  const lessDestructiveRef = React.useRef(null);

  const { mutate: updateOrganizationMutation, isLoading } =
    useUpdateOrganizationMutation();

  const deactivateMFA = () => {
    updateOrganizationMutation({
      mfa: { required: false },
      successCb() {
        props.onClose();
        toast({
          description: t('MFA disabled for all users'),
          status: 'success',
        });
      },
      errorCb() {
        props.onClose();
        toast({
          title: t('Something went wrong'),
          description: t('Try again'),
          status: 'error',
        });
      },
    });
  };

  return (
    <AlertDialog {...props} leastDestructiveRef={lessDestructiveRef}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader data-testid='MFADeactivationModal-header'>
            <T _str='Multi-factor authentication' />
          </AlertDialogHeader>
          <AlertDialogBody>
            <Text>
              Are you sure you want to disable MFA&nbsp;
              <strong>for all users in your organization?</strong>
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter>
            <ButtonGroup>
              <Button
                variant='ghost'
                onClick={props.onClose}
                ref={lessDestructiveRef}
                isDisabled={isLoading}
                data-testid='cancel-button'
              >
                <T _str='Cancel' />
              </Button>
              <Button
                colorScheme='danger'
                variant='solid'
                onClick={deactivateMFA}
                isLoading={isLoading}
                data-testid='deactivate-button'
              >
                Disable MFA
              </Button>
            </ButtonGroup>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default MFADeactivationModal;
